import { useEffect, useState,useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Box,Select,Text,Button,FormControl,FormLabel,FormErrorMessage,Input,Image,  useToast } from '@chakra-ui/react';
import { loadAllAttendanceData,addFeedback } from '../../redux/api_calls/apiCalls'

export default function Feedback() {
    const { attendanceDataAll } = useSelector(state => state.attendanceDataState)
    const dispatch = useDispatch();
    const centerNameRef = useRef();
    const sessionNameRef = useRef();
    const [selectedCenterNameValue, setSelectedCenterNameValue] = useState(null)
    const [selectedSessionValue, setSelectedSessionValue] = useState(null)
    const [centerNameData, setSelectedCenterNameValues] = useState([])
    const [SessionData, setSelectedSessionValues] = useState([])
    const [NameValue, setNameValue] = useState("");
    const [EmailValue, setEmailValue] = useState("");
    const [MobileNoValue, setMobileNoValue] = useState("");
    const [DOBValue, setDOBValue] = useState("");
    const [YearValue, setYearValue] = useState("");
    const [EmployeeValue, setEmployeeValue] = useState("");
    const [FeedbackValue, setFeedbackValue] = useState("");
    const [KnowledgeValue, setKnowledgeValue] = useState("");
    const [ScaleValue, setScaleValue] = useState("");

    const [DOBError, setDOBError] = useState(null);
    const [NameError, setNameError] = useState(null);
    const [EmailError, setEmailError] = useState(null);
    const [MobileNoError, setMobileNoError] = useState(null);
    const [CenterNameError, setCenterNameError] = useState(null);
    const [SessionNameError, setSessionNameError] = useState(null);
    const [YearError, setYearError] = useState(null);
    const [EmployeeError, setEmployeeError] = useState(null);
    const [FeedbackError, setFeedbackError] = useState(null);
    const [KnowledgeError, setKnowledgeError] = useState(null);
    const [ScaleError, setScaleError] = useState(null);

    const toast = useToast();
    
    useEffect(() => {
        dispatch(loadAllAttendanceData());
         if(attendanceDataAll!==undefined)
        {
            if(attendanceDataAll[0]!==undefined)
            {
                setSelectedCenterNameValues(attendanceDataAll[0]['center_names']);
                setSelectedSessionValues(attendanceDataAll[0]['session_names']);
            }
        }
    }, [dispatch,attendanceDataAll])
    
     const centerNameChangeHandler = () => {
         setCenterNameError(null);
        setSelectedCenterNameValue(centerNameRef.current.value)
    }

    const sessionNameChangeHandler = () => {
        setSessionNameError(null);
        setSelectedSessionValue(sessionNameRef.current.value)
    }

    
    const saveAttendance = async () => {
        let user_name = document.getElementById('user_name').value;
        if (!user_name.length) {
            setNameError("User Name is required")
            return true
        }
       
        let email = document.getElementById('email').value;
        if (!email.length) {
            setEmailError("Email is required")
            return true
        } 

        let mobile_number = document.getElementById('mobile_number').value;
        if (!mobile_number.length) {
            setMobileNoError("Mobile Number is required")
            return true
        } 
        let dob = document.getElementById('dob').value;
        if (!dob.length) {
            setDOBError("DOB is required")
            return true
        } 
        if (centerNameRef.current.value==="0") {
            setCenterNameError("Center Name is required")
            return true
        } 
         if (sessionNameRef.current.value==="0") {
            setSessionNameError("Session Name is required")
            return true
        } 
        let year = document.getElementById('year').value;
        if (!year.length) {
            setYearError("Year Attended is required")
            return true
        } 
        let empoyee_in_company = document.getElementById('employee_in_company').value;
        if (!empoyee_in_company.length) {
            setEmployeeError("Employee In Company a  is required")
            return true
        } 
        let feedback = document.getElementById('feedback').value;
        if (!feedback.length) {
            setFeedbackError("Feedback  is required")
            return true
        } 
        let knowledge = document.getElementById('knowledge').value;
        if (!knowledge.length) {
            setKnowledgeError("Knowledge is required")
            return true
        } 
         let scale_of_quantity = document.getElementById('scale_of_quantity').value;
        if (!scale_of_quantity.length) {
            setScaleError("Scale of quantity is required")
            return true
        } 
        let obj = {
                name: user_name,
                email: email,
                mobile_no: mobile_number,
                dob: dob,
                center_name: centerNameRef.current.value,
                session_name: sessionNameRef.current.value,
                year: year,
                employee_in_company: empoyee_in_company,
                feedback: feedback,
                implement_knowledge_in_ur_work: knowledge,
                scale_of_quantity:scale_of_quantity
            }
        try {
            await addFeedback(obj);
            
            toast({
                title: "Feedback Added Successfully!",
                status: "success",
                duration: 1000,
                isClosable: true,
            });
        }
        catch (err) {
              toast({
                title: err.response.data.message,
                description: "",
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            }
    }

    return (
     <Box
      w='100vw'
      minH='90vh'
      d='flex'
      justifyContent='center'
      alignItems='center'
      flexDir='column'
      transform='translateY(-50%, -50%)'
    >
            <Box width={['95%', '95%', '95%', '80%']}  justifyContent="center" alignItems='center' d='flex' mb='2rem'>
                      <Image src='../images/Logo.svg' width='300px' height='125px' objectFit='contain' />
            </Box>
            <Box width={['95%', '95%', '95%', '80%']}  justifyContent="center" alignItems='center' d='flex' mb='2rem'>
                      <Text  fontSize={['16px', '22px', '26px', '30px']}
        fontWeight='700'
        style={{ fontFamily: 'Mulish, sans-serif' }}
        color='#222222'
        mb='2rem'>Survey Form</Text>

                
            </Box>
            <Box
                width={["100%", "100%", "90%", "70%"]}
                d="flex"
                justifyContent="center"
                mb="1rem"
                pl='1rem'
                pb='1rem'
                pr='1rem'
                borderRadius='10px'
                flexDir='column'
            >
             <Box
                width={["100%", "100%", "100%", "100%"]}
                justifyContent="space-between"
                d="flex"
                flexDir="row"
            >
            <Box width="50%"  pr='1rem' >
                            <FormControl isInvalid={NameError}>
                                 <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Name
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="user_name"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                     placeholder='Enter Name'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={NameValue}
                                    onChange={(e) => {
                                        setNameError(null);
                                        setNameValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {NameError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="50%"  pb='1rem'>
                            <FormControl isInvalid={EmailError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                   Email
                                </FormLabel>
                                <Input
                                    type="email"
                                    color="#666666"
                                    id="email"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                     placeholder='Enter Email'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={EmailValue}
                                    onChange={(e) => {
                                        setEmailError(null);
                                        setEmailValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {EmailError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                 </Box>
                 <Box
                width={["100%", "100%", "100%", "100%"]}
                justifyContent="space-between"
                d="flex"
                flexDir="row"
            >
                        <Box width="50%"  pr='1rem'>
                            <FormControl isInvalid={MobileNoError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                   Mobile Number
                                </FormLabel>
                                <Input
                                    type="number"
                                    color="#666666"
                                    id="mobile_number"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                     placeholder='Enter Mobile Number'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={MobileNoValue}
                                    onChange={(e) => {
                                        setMobileNoError(null);
                                        setMobileNoValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {MobileNoError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="50%"  pb='1rem'>
                            <FormControl isInvalid={DOBError}>
                                 <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    DOB
                                </FormLabel>
                                <Input
                                    type="date"
                                    color="#666666"
                                    id="dob"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={DOBValue}
                                    onChange={(e) => {
                                        setDOBError(null);
                                        setDOBValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {DOBError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "100%", "100%"]}
                        justifyContent="space-between"
                        d="flex"
                        flexDir="row"
                        pb='1rem'
                        >
                        <Box width="50%" pr='1rem'>
                            <FormControl isInvalid={CenterNameError}>
                                 <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Center Name
                                </FormLabel>
                               <Select
                                    id='center_name'
                                    width={["100%", "100%", "90%", "100%"]}
                                    borderRadius='10px'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    height='40px'
                                    ref={centerNameRef}
                                    value={selectedCenterNameValue}
                                    onChange={centerNameChangeHandler}
                                    fontSize='18px'
                                    color="#666666"
                                >
                                    <option value='0' key='-1'>Select a Center Name</option>
                                        {
                                            centerNameData.map((centerName, idx) => <option value={centerName.center_name} key={idx}>{centerName.center_name}</option>)
                                        }
                                </Select>
                                <FormErrorMessage fontSize="sm">
                                    {CenterNameError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="50%">
                            <FormControl isInvalid={SessionNameError}>
                                 <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Session Name
                                </FormLabel>
                               <Select
                                    id='session_name'
                                    width={["100%", "100%", "90%", "100%"]}
                                    borderRadius='10px'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    height='40px'
                                    ref={sessionNameRef}
                                    value={selectedSessionValue}
                                    onChange={sessionNameChangeHandler}
                                    fontSize='18px'
                                    color="#666666"
                                >
                                                                    <option value='0' key='-1'>Select a Session Name</option>

                                    {SessionData!==undefined &&
                                SessionData.map((session, idx) => <option value={session.session_name} key={idx}>{session.session_name}</option>)
                            }
                                </Select>
                                <FormErrorMessage fontSize="sm">
                                    {SessionNameError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                width={["100%", "100%", "100%", "100%"]}
                justifyContent="space-between"
                d="flex"
                flexDir="row"
            >
            <Box width="50%"  pr='1rem' >
                            <FormControl isInvalid={YearError}>
                                 <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Year attended
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="year"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                     placeholder='Enter Year'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={YearValue}
                                    onChange={(e) => {
                                        setYearError(null);
                                        setYearValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {YearError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="50%"  pb='1rem'>
                            <FormControl isInvalid={EmployeeError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                   Are you an Employee in a company?
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="employee_in_company"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                     placeholder='Enter Yes or No'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={EmployeeValue}
                                    onChange={(e) => {
                                        setEmployeeError(null);
                                        setEmployeeValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {EmployeeError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                 </Box>
                  <Box
                width={["100%", "100%", "100%", "100%"]}
                justifyContent="space-between"
                d="flex"
                flexDir="row"
            >
            <Box width="50%"  pr='1rem'>
                            <FormControl isInvalid={FeedbackError}>
                                 <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    How helpful was the Session for you on your Interviews?
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="feedback"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                     placeholder='Enter Feedback'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={FeedbackValue}
                                    onChange={(e) => {
                                        setFeedbackError(null);
                                        setFeedbackValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {FeedbackError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="50%"  pb='1rem'>
                            <FormControl isInvalid={KnowledgeError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                   Were you able to implement the knowledge gained from the session in your Work?
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="knowledge"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={KnowledgeValue}
                                    onChange={(e) => {
                                        setKnowledgeError(null);
                                        setKnowledgeValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {KnowledgeError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                 </Box>
                   <Box
                width={["100%", "100%", "100%", "100%"]}
                justifyContent="space-between"
                d="flex"
                flexDir="row"
            >
            <Box width="100%"  pr='1rem'>
                            <FormControl isInvalid={ScaleError}>
                                 <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    On the scale of 1 to 5 rate the quality of the content from the Session attended.
                                </FormLabel>
                                <Input
                                    type="number"
                                    color="#666666"
                                    id="scale_of_quantity"
                                    width="100%"
                                    borderRadius='10px'
                                    size='md'
                                     placeholder='Enter 1 to 5 rate quality'
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    bg='#fcfcfc'
                                    value={ScaleValue}
                                    onChange={(e) => {
                                        setScaleError(null);
                                        setScaleValue(e.target.value);
                                    }}
                                    fontSize={["16px", "16px", "16px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {ScaleError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                      
                 </Box>
                        <Box width="100%">
                            <Button
                                  colorScheme='blue'
                                  size='lg'
                                  tabIndex='3'
                                  mt={4}
                                  bg='linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)'
                                  _hover={{ bg: 'linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)' }}
                                  boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                                  borderRadius='7px'
                                  fontSize='18px'
                                  fontWeight='900'
                                  style={{ fontFamily: 'Mulish, sans-serif' }}
                                  color='#ffffff'
                                  w='100%'
                                  h='50px'
                                  onClick={saveAttendance}
                              >
                            Submit
                          </Button>
                        </Box>
               
            </Box>
            
           
       
        </Box>
    )
}
